var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5832 38.5003C70.5832 56.2193 56.2188 70.5837 38.4998 70.5837C20.7807 70.5837 6.4165 56.2193 6.4165 38.5003C6.4165 20.7812 20.7807 6.41699 38.4998 6.41699C56.2188 6.41699 70.5832 20.7812 70.5832 38.5003Z",
    fill: "#7EFF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4307 28.778C52.3704 29.7177 52.3704 31.2413 51.4307 32.1809L35.389 48.2225C34.4493 49.1623 32.926 49.1623 31.9862 48.2225L25.5695 41.8059C24.6298 40.8661 24.6298 39.3428 25.5695 38.4031C26.5092 37.4634 28.0328 37.4634 28.9725 38.4031L33.6877 43.1181L40.8576 35.9481L48.0279 28.778C48.9677 27.8383 50.491 27.8383 51.4307 28.778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.a8fdc5e1ff51f7f2ed77d057e702c415.svg";
export { ForwardRef as ReactComponent };